import { initCartridgesShowcase } from '../components/cartdridgesShowcase';
import { initForMen } from '../components/forMen';
import { initPostTreatment } from '../components/postTreatment';
import { initProtocol } from '../components/protocol';
import { initWowSlider } from '../components/wowSlider';

export function initTreatmentPage() {
  initWowSlider();
  // initProtocol();
  initForMen();
  initPostTreatment();
  initCartridgesShowcase();

  console.log('📄 Treatment page initialized.');
}
